import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShortcut: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shortcut, hotkey, powerkey, skill"><path fillRule="evenodd" clipRule="evenodd" d="M19.25 3C20.2165 3 21 3.7835 21 4.75V19.25C21 20.2165 20.2165 21 19.25 21H4.75C3.7835 21 3 20.2165 3 19.25V4.75C3 3.7835 3.7835 3 4.75 3H19.25ZM13.3652 7.8291C13.508 7.30557 12.8313 6.96125 12.4922 7.38477L8.64941 12.1875C8.38774 12.5148 8.62101 12.9998 9.04004 13H11.5L10.6348 16.1709C10.492 16.6944 11.1687 17.0388 11.5078 16.6152L15.3506 11.8125C15.6123 11.4852 15.379 11.0002 14.96 11H12.5L13.3652 7.8291Z" fill="currentColor"/></CentralIconBase>;
};

export default IconShortcut;
